export default __webpack_public_path__ + "static/media/benefit_5.e3ede897.svg";